import { GET_LIKES } from "./types";

const initalState = {
  likes: [],
};

export const likeReducer = (state = initalState, action) => {
  switch (action.type) {
    case GET_LIKES:
      return {
        likes: action.payload,
      };
    default:
      return state;
  }
};
